/**
 * Maintenance mode configuration.
 * Set `enabled: true` and rebuild to show the maintenance screen to logged-in users.
 * The rest of the fields control the copy shown on that screen.
 */
export const MAINTENANCE_CONFIG = {
  /** Toggle to true to activate maintenance mode — then rebuild & deploy. */
  enabled: false,

  /** Headline shown in the large Anton display font. Keep it short (2–4 words). */
  title: 'Platform Update',

  /** Supporting body copy. One or two sentences max. */
  message: "We're applying improvements to deliver a better experience. The platform will be back online shortly.",

  /**
   * Optional estimated return time shown in accent colour below the message.
   * Leave empty string to hide it entirely.
   * Example: 'Back online today at 18:00 CET'
   */
  estimatedTime: '',
} as const;
